/**
 * Component that generates and applies global font-face styles.
 *
 * This component uses the `@emotion/react` library to inject global styles for custom fonts.
 * It dynamically generates the `@font-face` CSS rules based on the `fontImports` configuration.
 *
 * @returns {JSX.Element} A React component that applies global font-face styles.
 */
import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {delonghiFontImports, nutribulletFontImports} from '../../theme/import/utils'
import {BRAND_KEY} from '../../brand'

export const Fonts = () => {
    let fonts
    switch (BRAND_KEY) {
        case 'nutribullet':
            fonts = nutribulletFontImports
            break
        case 'delonghi':
        default:
            fonts = delonghiFontImports
            break
    }

    const fontFaceGenerate = () => {
        var importFontString = ''

        fonts.forEach((font) => {
            font.variants.forEach((variant) => {
                const fileName = `${font.family}${variant.name}`
                const fontPath = `static/fonts/${font.folder}/${font.family}/${fileName}`
                importFontString += `
                @font-face {
                    font-family: '${font.family}';
                    src:  url(${getAssetUrl(`${fontPath}.woff2`)}) format('woff2');
                    font-display: swap;
                    font-weight: ${variant.weight};
                }
                `
            })
        })

        return importFontString
    }

    const generatedStyleForFonts = fontFaceGenerate()
    return <Global styles={generatedStyleForFonts} />
}
